import React from 'react';

interface Props {
    data: string
}

const UnSupportedFormatComponent: React.FC<Props> = ({data}) => {
   
    return (
        <div className='w-100 h-100 flex al-it-c'>
            <h3 className='w-100 t-center'>{data}</h3>
        </div>
    )
};

export default UnSupportedFormatComponent
